import { Api } from "./Api";
import { config } from "@/config";

export const FileApi = {
  async linkRequest(file: any, type: string) {
    const bucketName = config.REACT_APP_AWS_S3_BUCKET_NAME;
    const bucketZone = config.REACT_APP_AWS_S3_BUCKET_ZONE;
    try {
      if (!bucketName || !bucketZone)
        throw new Error("Dohvaćanje linka neuspješno!");

      const { data: uploadLinkRequest } = await Api.get(
        `/file/upload-link/${type}`
      );

      const uploadLink = uploadLinkRequest?.payload?.link;
      const uploadUuid = uploadLinkRequest?.payload?.uuid;

      if (!uploadLink) throw new Error("Dohvaćanje linka neuspješno!");

      await fetch(uploadLink, {
        method: "PUT",
        body: file,
        headers: {
          "Content-Type": file.type || "application/octet-stream",
        },
      });

      return `https://${bucketName}.s3.${bucketZone}.amazonaws.com/${type}/${uploadUuid}`;
    } catch (error) {
      console.log(error);
    }
  },
  async getFile(url: string) {
    try {
      const response = await Api.get(`/file/get-file?url=${url}`, {
        responseType: "blob",
      });
      return response.data ?? null;
    } catch (error) {
      console.log(error);
    }
  },
};
